<template>
  <adminTable :showExpand="true" :tableLoading="tableLoading" :totalList="totalList" v-model:page="page"
    v-model:limit="limit" v-model:searchForm="searchForm" :tableData="tableData" @search="searchList">
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.id" placeholder="请输入用户ID" prop="id" clearable />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.nickname" placeholder="请输入用户名" prop="nickname" clearable />
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="请输入手机号码" prop="phone" clearable />
      </el-form-item>
      <el-select v-model="searchForm.sort_by" placeholder="排序字段" clearable>
        <el-option label="积分" value="points" />
        <el-option label="余额" value="money" />
        <el-option label="冻结余额" value="frozen_money" />
        <el-option label="经验" value="experience" />
      </el-select>
      <el-form-item>
        <el-select v-model="searchForm.sort_order" placeholder="排序方式" clearable>
          <el-option label="升序" value="asc" />
          <el-option label="降序" value="desc" />
        </el-select>
      </el-form-item>
      <el-form-item> </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.invite" placeholder="请输入邀请码" prop="invite" clearable />
      </el-form-item>
      <el-form-item>
        <el-col :span="11">
          <el-date-picker v-model="searchForm.starttime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="注册开始时间" style="width: 100%" prop="starttime" />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker v-model="searchForm.endtime" type="datetime" value-format="YYYY-MM-DD HH:mm:ss" prop="endtime"
            placeholder="注册结束时间" style="width: 100%" />
        </el-col>
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button type="primary" v-permission icon="CirclePlus" @click="editItems('add', {})">添加</el-button>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="avatar" label="头像" width="80">
        <template #default="scope">
          <el-avatar v-if="scope.row.avatar" :src="getAvatarUrl(scope.row.avatar)" :size="40" fit="cover" />
          <el-avatar v-else :size="40">
            {{ scope.row.nickname ? scope.row.nickname.charAt(0) : 'U' }}
          </el-avatar>
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" width="100" />
      <el-table-column prop="phone" label="手机号码" width="100">
        <template #default="scope">
          <span>{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="user_type" label="账号类型" width="130">
        <template #default="scope">
          <span v-if="scope.row.user_type === 'normal'">普通用户</span>
          <span v-if="scope.row.user_type === 'expert'">专家</span>
          <span v-if="scope.row.user_type === 'test'">测试账号</span>
          <span v-else>{{ scope.row.user_type }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="invite" label="邀请码" width="70">
        <template #default="scope">
          <span>{{ scope.row.invite }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="addtime" label="注册时间" width="220">
        <template #default="scope">
          <span>
            注册时间：{{ scope.row.created_at }}
            <br />
            最后登录IP: {{ scope.row.last_login_ip }}
            <br />
            最后登录时间：{{ scope.row.last_login_at }}
            <br />
            登录次数：{{ scope.row.login_count }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="会员统计" width="180">
        <template #default="scope">
          <span>
            余额：{{ scope.row.money }} <br />
            积分：{{ scope.row.points }}<br />
            经验：{{ scope.row.experience }}<br />
            等级：{{ scope.row.level }}<br />
            用户类型：{{ scope.row.user_type }}<br />
            验证状态：{{ scope.row.is_verified ? "已验证" : "未验证" }}<br />
          </span>
        </template>
      </el-table-column>

      <el-table-column label="推荐人" width="180">
        <template #default="scope">
          <div v-if="scope.row.invited_by_phone">
            上级ID: {{ scope.row.invited_by_id }}<br />
            上级手机: {{ scope.row.invited_by_phone }}<br />
          </div>
          <div v-else>无上级</div>
          <div style="margin-top: 5px; color: #409eff">
            已邀请: {{ scope.row.invited_count || 0 }} 人
          </div>
        </template>
      </el-table-column>
      <el-table-column v-if="currentUser.role == 0" fixed="right" prop="address" width="330" label="操作">
        <template #default="scope">
          <el-button type="info" icon="User" v-permission @click="editItems('info', scope.row)">信息</el-button>

          <el-button type="warning" icon="Wallet" v-permission @click="editItems('money', scope.row)">金额</el-button>
          <el-button type="danger" icon="Delete" v-permission @click="deleteUser(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </template>
    <el-dialog v-model="dialogFlag" title="操作" :width="['levelOne', 'levelTwo'].includes(dialogType) ? '90%' : 1050">
      <editUserForm :key="currentRow" v-if="dialogType === 'add' || dialogType === 'edit'" ref="editUserFormRef"
        :type="dialogType" :item="currentRow" />
      <userMoneyForm :key="currentRow" v-if="dialogType === 'money'" ref="userMoneyFormRef" :item="currentRow" />
      <userStateForm :key="currentRow" v-if="dialogType === 'state'" ref="userStateFormRef" :item="currentRow" />
      <userInfoForm :key="currentRow" v-if="dialogType === 'info'" ref="userInfoFormRef" :item="currentRow" />

      <limitUserForm :key="currentRow" v-if="dialogType === 'limitUser'" ref="limitUserRef" :item="currentRow" />
      <limitLoginForm :key="currentRow" v-if="dialogType === 'limitLogin'" ref="limitLoginRef" :item="currentRow" />
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, nextTick } from "vue";
import editUserForm from "./components/userList/editUserForm.vue";
import userMoneyForm from "./components/userList/userMoneyForm.vue";
import userStateForm from "./components/userList/userStateForm.vue";
import userInfoForm from "./components/userList/userInfoForm.vue";
import limitUserForm from "./components/userList/limitUserForm.vue";
import limitLoginForm from "./components/userList/limitLoginForm.vue";
import { accountTypeEnums, booleanEnums, getLabelByVal } from "@/config/enums";
import { ElMessage, ElMessageBox } from "element-plus";
import { useRouter } from "vue-router";

const searchForm = ref({
  id: "",
  phone: "",
  nickname: "",
  level: "",
  user_type: "",
  status: "",
  is_verified: "",
  expert_status: "",
  sort_by: "",
  sort_order: "",
  invitation_code: "",
  starttime: "",
  endtime: "",
});
const tableData = ref([]);
const dialogFlag = ref(false);
const dialogType = ref("add");
const currentRow = ref({});

const editUserFormRef = ref(null);
const userStateFormRef = ref(null);
const userInfoFormRef = ref(null);
const limitUserRef = ref(null);

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const { proxy } = getCurrentInstance();

// Helper function to construct avatar URL
const getAvatarUrl = (avatar) => {
  if (!avatar) return '';
  
  // If it's already a full URL (external), return as-is
  if (avatar.startsWith('http://') || avatar.startsWith('https://')) {
    return avatar;
  }
  
  // If it's a relative path (uploaded file), construct full URL using API base
  return `http://0118tk-api.test:8000${avatar}`;
};

onMounted(() => {
  getList();
});

const router = useRouter();

const searchList = () => {
  getList();
};

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);

const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    method: "get",
    url: "/user/getUserLists",
    params: {
      page: page.value,
      limit: limit.value,
      ...searchForm.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
  }
};

const editItems = (type, row = {}) => {
  currentRow.value = row;
  dialogType.value = type;

  // 如果是修改邀请码，需要设置表单初始值
  if (type === "invite") {
    nextTick(() => {
      if (editInviteFormRef.value) {
        editInviteFormRef.value.form.id = row.id;
        editInviteFormRef.value.form.current_invite = row.invite;
        editInviteFormRef.value.form.invite = "";
      }
    });
  }

  dialogFlag.value = true;
};

const submitForm = async () => {
  if (dialogType.value == "money") {
    userMoneyFormRef.value.formRef.validate(async (valid) => {
      if (valid) {
        const data = userMoneyFormRef.value.form;
        const res = await proxy.$http({
          method: "post",
          url: "MoneyLog/addMoney",
          data: {
            uid: data.id,
            class_id: data.class_id,
            type: data.type,
            money: data.money3,
            desc: data.desc,
          },
        });
        dialogFlag.value = false;
        if (res.code == 0) {
          ElMessage({
            type: "success",
            message: res.msg,
          });
        } else {
          ElMessage({
            type: "error",
            message: res.msg,
          });
        }
        getList();
      }
    });
  } else if (dialogType.value == "add" || dialogType.value == "edit") {
    // 新增用户
    const url = dialogType.value == "add" ? "User/addUser" : "";
    const data = editUserFormRef.value.form;
    if (dialogType.value == "add") {
      data.id = null;
    }
    const res = await proxy.$http({
      method: "post",
      url: url,
      data: {
        phone: data.phone,
        invite: data.invite,
        password: data.password,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  } else if (dialogType.value == "state") {
    // 用户状态
    const data = userStateFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/updateUserState",
      data: {
        uid: data.id,
        ban_buy: data.ban_buy,
        ban_sigin: data.ban_sigin,
        ban_raffle: data.ban_raffle,
        ban_login: data.ban_login,
        ban_invite: data.ban_invite,
        ban_recharge: data.ban_recharge,
        ban_withdraw: data.ban_withdraw,
        ban_exchange: data.ban_exchange,
        kick_out: data.kick_out,
        is_valid_user: data.is_valid_user,
      },
    });
    dialogFlag.value = false;
    if (res.code == 0) {
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
    getList();
  } else if (dialogType.value == "info") {
    // 用户信息
    const data = userInfoFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/updateUser",
      data: {
        id: data.id,
        nickname: data.nickname,
        password: data.password,
        phone: data.phone,
        email: data.email,
        avatar: data.avatar,
        level: data.level,
        status: data.status,
        user_type: data.user_type,
      },
    });
    dialogFlag.value = false;
    if (res.code == 0) {
      // Update local table data immediately
      const userIndex = tableData.value.findIndex(user => user.id == data.id);
      if (userIndex !== -1) {
        tableData.value[userIndex] = {
          ...tableData.value[userIndex],
          nickname: data.nickname,
          user_type: data.user_type,
          status: data.status,
          is_verified: data.is_verified,
          expert_status: data.expert_status,
          phone: data.phone,
          email: data.email,
          avatar: data.avatar,
        };
      }

      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  } else if (dialogType.value == "count") {
    // 用户统计
    const data = userCountFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/updateUser",
      data: {
        id: data.id,
        points: data.points,
        experience: data.experience,
        money: data.money,
        frozen_money: data.frozen_money,
      },
    });
    dialogFlag.value = false;
    if (res.code == 0) {
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
    getList();
  } else if (dialogType.value == "transfer") {
    const data = transferFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/deleteUser",
      data: {
        from_user: data.from_user,
        to_user: data.to_user,
        // lv: data.lv,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  } else if (dialogType.value == "limitLogin") {
    const data = limitLoginRef.value.form;
    console.log(data);
    console.log(data.ban_login);
    const res = await proxy.$http({
      method: "post",
      url: "user/setBanTeamLogin",
      data: {
        ban_login: data.ban_login,
        id: data.id,
        phone: data.phone,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  } else if (dialogType.value == "limitUser") {
    const data = limitUserRef.value.form;
    console.log(data.ban_limit);
    const res = await proxy.$http({
      method: "post",
      url: "user/setBanTeamLimit",
      data: {
        ban_limit: data.ban_limit,
        id: data.id,
        phone: data.phone,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  } else if (dialogType.value == "invite") {
    // 修改邀请码
    const data = editInviteFormRef.value.form;

    // 验证新邀请码不能为空
    if (!data.invite || data.invite.trim() === "") {
      ElMessage({
        type: "error",
        message: "请输入新的邀请码",
      });
      return;
    }

    const res = await proxy.$http({
      method: "post",
      url: "user/editInviteCode",
      data: {
        id: data.id,
        invite: data.invite.trim(),
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  }
};

const deleteAction = (row) => {
  ElMessageBox.confirm("是否删除?", "Warning", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      ElMessage({
        type: "success",
        message: "删除成功",
      });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消删除",
      });
    });
};

const deleteUser = (row) => {
  ElMessageBox.confirm(
    `确定要删除用户 "${row.nickname}" 吗？此操作不可恢复！`,
    '删除确认',
    {
      confirmButtonText: '确认删除',
      cancelButtonText: '取消',
      type: 'warning',
      confirmButtonClass: 'el-button--danger',
    }
  )
    .then(async () => {
      try {
        const res = await proxy.$http({
          method: 'post',
          url: 'user/deleteUser',
          data: {
            id: row.id
          }
        });

        if (res.code === 0) {
          const userIndex = tableData.value.findIndex(user => user.id === row.id);
          if (userIndex !== -1) {
            tableData.value.splice(userIndex, 1);
            totalList.value -= 1;
          }

          ElMessage({
            type: 'success',
            message: '删除成功'
          });
        } else {
          ElMessage({
            type: 'error',
            message: res.msg || '删除失败'
          });
        }
      } catch (error) {
        ElMessage({
          type: 'error',
          message: '删除失败，请重试'
        });
      }
    })
    .catch(() => {
      ElMessage({
        type: 'info',
        message: '已取消删除'
      });
    });
}
</script>

<style lang="less" scoped>
.table-handle-td {
  display: flex;
  cursor: pointer;
  flex-wrap: wrap;

  button {
    margin-bottom: 10px;
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
